import { toast } from "react-toastify"
import { api } from "~/utils/api"
import { invalidateAdjustmentQueries } from "~/utils/cacheUtils/adjustmentCacheHelpers"
import { useRefreshForecastDomain } from "~/utils/cacheUtils/forecastCacheHelpers"
import { showErrorToast } from "~/utils/toaster"

export function useAddVariantsToAdjustment() {
  const utils = api.useUtils()
  const refreshForecastDomain = useRefreshForecastDomain()

  return api.adjustment.addVariantsToAdjustment.useMutation({
    onSuccess: async (data) => {
      if (data.addedCount > 0) {
        // Every variant on the adjustment was re-split, not just the added ones — the partial
        // cache merge only covers the ids passed here, so anything left out stays stale.
        await refreshForecastDomain(data.affectedVariantIds)
        toast.success(`Added ${data.addedCount} variant(s) to "${data.name}"`)
      } else {
        invalidateAdjustmentQueries(utils)
        toast.info("All selected variants are already in this adjustment")
      }
    },
    onError: (error) => {
      showErrorToast(error)
      invalidateAdjustmentQueries(utils)
    },
  })
}

export function useRemoveVariantsFromAdjustment() {
  const utils = api.useUtils()
  const refreshForecastDomain = useRefreshForecastDomain()

  return api.adjustment.removeVariants.useMutation({
    onSuccess: async (data, variables) => {
      // Includes the survivors, whose shares were rewritten by the removal.
      await refreshForecastDomain(data.affectedVariantIds)
      toast.success(`Removed ${variables.variantIds.length} variant(s) from adjustment`)
    },
    onError: (error) => {
      showErrorToast(error)
      invalidateAdjustmentQueries(utils)
    },
  })
}
